module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Semibold.cf400569.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Semibold.woff2
// module id = 340
// module chunks = 3